import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import Factures from "./pages/Factures";
import FactureForm from "./pages/FactureForm";
import Clients from "./pages/Clients";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Settings from "./pages/Settings";
import { AuthProvider, useAuth } from "./contexts/AuthContext";

function ProtectedShell({ children }) {
  const { user, ready } = useAuth();
  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: "#F9F8F6" }}>
        <div className="text-[#5C665E] text-sm">Chargement...</div>
      </div>
    );
  }
  if (!user || typeof user !== "object") {
    return <Navigate to="/login" replace />;
  }
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              element={
                <ProtectedShell>
                  <Layout />
                </ProtectedShell>
              }
            >
              <Route path="/" element={<Dashboard />} />
              <Route path="/factures" element={<Factures />} />
              <Route path="/factures/nouveau" element={<FactureForm />} />
              <Route path="/factures/:id/edit" element={<FactureForm />} />
              <Route path="/clients" element={<Clients />} />
              <Route path="/settings" element={<Settings />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
